import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ToastProvider from './usalco_lib/ToastProvider';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { registerLicense } from '@syncfusion/ej2-base';
import axios from 'axios';
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";

registerLicense('ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5bdENiWXxXcnNQQmZfWkdy');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                  <ToastProvider>
                        <App />
                  </ToastProvider>
            </BrowserRouter>
      </ThemeProvider>
);

axios.defaults.withCredentials = true;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
